import { render, staticRenderFns } from "./stocktransfers.vue?vue&type=template&id=e35d7b3a&"
import script from "./stocktransfers.vue?vue&type=script&lang=js&"
export * from "./stocktransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports